import { render, staticRenderFns } from "./VFieldText.vue?vue&type=template&id=42380ab5&"
import script from "./VFieldText.vue?vue&type=script&lang=js&"
export * from "./VFieldText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lucas/projects/work/autoag/autoagtruck.ch/wp-content/themes/autoag/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42380ab5')) {
      api.createRecord('42380ab5', component.options)
    } else {
      api.reload('42380ab5', component.options)
    }
    module.hot.accept("./VFieldText.vue?vue&type=template&id=42380ab5&", function () {
      api.rerender('42380ab5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/scripts/VForm/VFieldText.vue"
export default component.exports